import { periodLabelMap as o } from "./periodLabelMap.js";
import { useLocalisation as a } from "../../utils/hooks/useLocalisation.js";
const n = (r, t) => {
  const { formatDate: e } = a();
  return t ? r !== "custom" ? o[r] : `${e(t.from, "PP")} - ${e(t.to, "PP")}` : "Select dates...";
};
export {
  n as useDateRangePickerLabel
};
//# sourceMappingURL=useDateRangePickerLabel.js.map
